'use strict'

var KM = KM || {
  vendor: 'King & McGaw'
}

KM.isPodProduct = function (product) {
  if (product && product.vendor) {
    return product.vendor === KM.vendor
  }
}

KM.initialize = function (options) {
  this.product = options.product || {}
  this.variantMetafields = options.variantMetafields || {}
  this.frameSelections = options.frameSelections || {}
  this.framePicker = $('.pod-frame-picker').first()
  this.shopifyFrameSelector = {}
}

KM.titleize = function (string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

KM.showFrame = function (label) {
  try {
    return !!_.find(kmProduct.variants, function (variant) {
      return variant.title.match(label)
    })
  } catch (e) {
    // if something goes wrong, (log?/alert?) and err on the side of "Yes!"
    return true
  }
}

KM.buildFramePicker = function (size) {
  this.framePicker = $('.pod-frame-picker')
  this.framePicker.html('')
  var frameDivs = []
  var shopifyFrameSelectorElement = this.shopifyFrameSelector

  this.frameSelections[_.lowerCase(size)].forEach(function (frame) {
    var cssClass =
      $(shopifyFrameSelectorElement).val() === frame.label
        ? 'frame current'
        : 'frame'

    var $frameDiv = $(
      '<li class="'
        .concat(cssClass, '" data-frame-value="')
        .concat(frame.label, '" data-frame-id="')
        .concat(frame.frame_id, '"><img src="')
        .concat(frame.image, '" alt="')
        .concat(frame.title, '" title="')
        .concat(frame.title, '" /></li>')
    )

    if (KM.showFrame(frame.label)) {
      frameDivs.push($frameDiv)
    }
  })

  var cssClass =
    $(shopifyFrameSelectorElement).val() === 'none' ? 'frame current' : 'frame'

  if (KM.showFrame('none')) {
    frameDivs.push(
      $(
        '<li class="'.concat(
          cssClass,
          '" data-frame-value="none"><div class="no-frame">no frame</div></li>'
        )
      )
    )
  }

  this.framePicker.append(frameDivs).show()
  $(shopifyFrameSelectorElement).hide()
  this.framePicker.find('.frame').click($.proxy(this.selectFrame, this))
}

KM.handlePODSelection = function (product, variant) {
  if (!KM.isPodProduct(product.product)) {
    return true
  }

  var typeSelector = $('select[data-option=option1]').first()
  var sizeSelector = $('select[data-option=option2]').first()
  this.shopifyFrameSelector = $('select[data-option=option3]').first()
  var isCanvas =
    $(typeSelector).val() === 'unstretched canvas' ||
    $(typeSelector).val() === 'stretched canvas'

  if (!variant || !variant.available) {
    if (isCanvas) {
      // ensure no frame is selected
      $(this.shopifyFrameSelector).val('none')
      $(this.shopifyFrameSelector).trigger('change')
      return false
    }
  }

  if (isCanvas) {
    $(this.shopifyFrameSelector).parents('.selector-wrapper:first').hide()
    this.framePicker.hide()
  } else {
    $(this.shopifyFrameSelector).parents('.selector-wrapper:first').show()
    this.buildFramePicker($(sizeSelector).val())
  }

  KM.updatePageDescription(variant)

  return true
}

KM.updatePageDescription = function (variant) {
  var metaFields = this.variantMetafields[variant.id]

  var productSummary = []
  var productDescription = metaFields['product-description']
  productSummary.push(KM.titleize(productDescription))

  if (metaFields['product-height']) {
    var productDimensions = `${metaFields['product-height'].value} x ${metaFields['product-width'].value} cm`
    var imageDimensions = `${metaFields['image-height'].value} x ${metaFields['image-width'].value} cm`
  } else {
    var productDimensions = metaFields['product-dimensions-cm']
    var imageDimensions = metaFields['image-dimensions-cm']
  }

  productSummary.push(`Overall size of this product is: ${productDimensions}`)
  productSummary.push(
    `The image area of the print measures: ${imageDimensions}`
  )

  $('#km-product-summary').remove()
  var html =
    '<div id="km-product-summary" class="product-meta" style="margin-top:20px;"><h4>Product size</h4>' +
    productSummary.join('<br>') +
    '</div>'
  $('#product-description').after(html)
}

KM.selectFrame = function (e) {
  var frameVal = $(e.currentTarget).data('frame-value')
  this.framePicker.find('.frame').removeClass('current')
  $(e.currentTarget).addClass('current')
  $(this.shopifyFrameSelector).val(frameVal)
  $(this.shopifyFrameSelector).trigger('change')
}
